import React from 'react'
import { createRoot } from "react-dom/client"
import { Mid } from '@mid/sdk'
import './index.css'
import LoginWrapper from './Components/Home/LoginWrapper'
import configurations from './Utility/ConfigUtility'
import LoadingPage from './Components/Home/Login'
import Home from './Components/Home/Home'
import './Styles/Colors.css'

const mid = new Mid({
  redirectUrl: `${configurations.redirectBaseUrl}/${configurations.subPath}/auth/callback`,
  logoutRedirectUrl: `${configurations.redirectBaseUrl}/${configurations.subPath}/logout`,
  loginInfo: {
    appId: configurations.clientId,
    oidcConfigUrl: configurations.oidcConfigUrl,
    authDriver: 'mid',
  },
  async landingFn(): Promise<void> {
    window.location.hash = ''
  },
})

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render((
  <LoginWrapper mid={mid} loadingNode={(props) => <LoadingPage {...props} />}>
    <Home />
  </LoginWrapper>
))
